import { render, staticRenderFns } from "./DelToponym.vue?vue&type=template&id=b1853294&"
import script from "./DelToponym.vue?vue&type=script&lang=js&"
export * from "./DelToponym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports